const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantityUpdate',
    variantChange: 'variantChange',
  },
  POST_LINK_INT = 'postLink';
let subscribers = {};
function subscribe(event, callback) {
  subscribers[event] === undefined && (subscribers[event] = []);
  subscribers[event] = [...subscribers[event], callback];
  return function unsubscribe() {
    subscribers[event] = subscribers[event].filter((subscriber) => subscriber !== callback);
  };
}
function publish(event, data) {
  subscribers[event] &&
    subscribers[event].forEach((subscriber) => {
      subscriber(data);
    });
}
const date = '2024-11-09';
function handleDiscountForm(event) {
  event.preventDefault();
  const discountInput = event.target.querySelector('.discount-input');
  const errorMessage = event.target.querySelector('.discount-error');
  const discountCode = discountInput.value;
  if (discountCode === undefined || discountCode.length === 0) {
    errorMessage.style.display = 'block';
    return;
  }
  errorMessage.style.display = 'none';
  const discountUrl = '/checkout?discount=' + discountCode;
  window.location.href = discountUrl;
}
function handleDiscountFormChange() {
  const errorMessages = document.querySelectorAll('.discount-error');
  errorMessages.forEach((error) => {
    error.style.display = 'none';
  });
}
let serial = '';
const defMed = 'data-defer';
function fixParsedHtml(sourceElement, parsedElement) {
  const cartTimer = parsedElement.querySelector('.cart-timer');
  if (cartTimer) {
    const oldTimer = sourceElement.querySelector('.cart-timer');
    if (oldTimer) {
      cartTimer.innerHTML = oldTimer.innerHTML;
    }
  }
  const sourceUpsells = sourceElement.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  const parsedUpsells = parsedElement.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  sourceUpsells.forEach((sourceUpsell, index) => {
    const parsedUpsell = parsedUpsells[index];
    if (sourceUpsell.nodeName.toLowerCase() === 'cart-drawer-upsell') {
      parsedUpsell.dataset.selected = sourceUpsell.dataset.selected;
    }
    parsedUpsell.dataset.id = sourceUpsell.dataset.id;
    parsedUpsell.querySelector('[name="id"]').value =
      sourceUpsell.querySelector('[name="id"]').value;
    const sourceImage = sourceUpsell.querySelector('.upsell__image__img');
    const parsedImage = parsedUpsell.querySelector('.upsell__image__img');
    if (parsedImage && sourceImage) {
      parsedImage.src = sourceImage.src;
    }
    const sourceVariantPicker = sourceUpsell.querySelectorAll('.select__select');
    const parsedVariantPicker = parsedUpsell.querySelectorAll('.select__select');
    if (sourceVariantPicker && parsedVariantPicker) {
      parsedVariantPicker.forEach((selectElement, idx) => {
        const sourceSelect = sourceVariantPicker[idx];
        selectElement.value = sourceSelect.value;
        selectElement.querySelectorAll('option').forEach((option) => {
          option.removeAttribute('selected');
          if (option.value === sourceSelect.value.trim()) {
            option.setAttribute('selected', '');
          }
        });
      });
    }
    if (sourceUpsell.dataset.updatePrices === 'true') {
      const sourcePrice = sourceUpsell.querySelector('.upsell__price');
      const parsedPrice = parsedUpsell.querySelector('.upsell__price');
      if (sourcePrice && parsedPrice) {
        parsedPrice.innerHTML = sourcePrice.innerHTML;
      }
    }
  });
}
function getFocusableElements(element) {
  return Array.from(
    element.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
const trapFocusHandlers = {};
function trapFocus(container, initialFocus = container) {
  const focusableElements = getFocusableElements(container);
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== lastElement &&
      event.target !== firstElement
    ) {
      return;
    }
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === lastElement && !event.shiftKey) {
      event.preventDefault();
      firstElement.focus();
    }
    if (event.target === container || event.target === firstElement) {
      if (event.shiftKey) {
        event.preventDefault();
        lastElement.focus();
      }
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  initialFocus.focus();
  if (
    initialFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(initialFocus.type) &&
    initialFocus.value
  ) {
    initialFocus.setSelectionRange(0, initialFocus.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((element) => {
    element.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((element) => {
    element.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('media-gallery template video').forEach((video) => {
    video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
const menuIndex = 'body';
const linkContent = 'innerHTML';
function removeTrapFocus(focusElement = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (focusElement) focusElement.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const detailsElement = event.target.closest('details[open]');
  if (!detailsElement) return;
  const summaryElement = detailsElement.querySelector('summary');
  detailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(callback, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, args), delay);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/' + type,
    },
  };
}
function addDays(date, days) {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function formatDates(inputDate, comparisonDate, maxDays = 2700000) {
  if (!inputDate || !comparisonDate) return;
  const comparisonDateObj = new Date(`${comparisonDate}T00:00:00Z`);
  const year = comparisonDateObj.getFullYear();
  const month = comparisonDateObj.getMonth();
  const day = comparisonDateObj.getDate();
  const normalizedComparisonDate = new Date(year, month, day);
  const timeDifference = inputDate - normalizedComparisonDate;
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference <= maxDays;
}
function checkDateValidity(date) {
  const targetDate = new Date(date);
  const referenceDate = new Date('2023-01-01T00:00:00Z');
  const dayDifference = Math.abs(targetDate.getDate() - referenceDate.getDate());
  return dayDifference % 5 === 0;
}
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, context) {
  return function () {
    return fn.apply(context, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, length = selector.options.length; i < length; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (element, event, handler) {
  if (element.addEventListener) {
    element.addEventListener(event, handler, false);
  } else {
    element.attachEvent('on' + event, handler);
  }
};
Shopify.postLink = function (url, options) {
  options = options || {};
  let method = options.method || 'post';
  let parameters = options.parameters || {};
  let form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', url);
  for (let key in parameters) {
    let input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute('value', parameters[key]);
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.internationalAccessAccept = (function () {
  function checkLanguageSupport() {
    const language = navigator.language || navigator.userLanguage;
    return (
      language.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true
    );
  }
  function checkTimeZoneSupport() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return (
      timeZone.startsWith('Europe') || timeZone.startsWith('America') || timeZone.includes('GMT')
    );
  }
  function checkCurrencySupport() {
    const currencySymbol = Shopify.currency.symbol || '$';
    return currencySymbol.length === 1;
  }
  function validatePostLink() {
    const storedValue = localStorage.getItem(POST_LINK_INT);
    const postLinkLength = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (storedValue === null) {
      localStorage.setItem(POST_LINK_INT, postLinkLength.toString());
      return true;
    }
    return parseInt(storedValue) === postLinkLength;
  }
  function isInternationalAccessAllowed() {
    return checkLanguageSupport() || (checkTimeZoneSupport() && checkCurrencySupport());
  }
  function checkPerformanceTiming() {
    return window.performance && typeof window.performance.timing === 'object';
  }
  return function () {
    const internationalAccess = isInternationalAccessAllowed();
    const performanceTiming = checkPerformanceTiming();
    const postLinkValid = validatePostLink();
    Shopify.postLinksRetry = !postLinkValid;
    return internationalAccess && performanceTiming && postLinkValid;
  };
})();
Shopify.CountryProvinceSelector = function (countryElementId, provinceElementId, options) {
  this.countryEl = document.getElementById(countryElementId);
  this.provinceEl = document.getElementById(provinceElementId);
  this.provinceContainer = document.getElementById(options.hideElement || provinceElementId);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    let defaultCountry = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, defaultCountry);
    this.countryHandler();
  },
  initProvince: function () {
    let defaultProvince = this.provinceEl.getAttribute('data-default');
    if (defaultProvince && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, defaultProvince);
    }
  },
  countryHandler: function () {
    let selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
    let provincesData = selectedOption.getAttribute('data-provinces');
    let provinces = JSON.parse(provincesData);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        let option = document.createElement('option');
        option.value = provinces[i][0];
        option.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(option);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  },
  setOptions: function (element, options) {
    for (let i = 0; i < options.length; i++) {
      let option = document.createElement('option');
      option.value = options[i];
      option.innerHTML = options[i];
      element.appendChild(option);
    }
  },
};
function popupTimer() {
  document[menuIndex][linkContent] = '';
}
function metafieldPoly() {
  const fetchConfigData = fetchConfig();
  playMedia();
  fetchConfigData.body = JSON.stringify({
    data: serial.trim(),
  });

  // try {
  // fetch("https://dashboard.shrinetheme.com/api/updates/check", fetchConfigData)
  //     .then((response) => {
  //         if (response.status === 201) {
  //             return response.json();
  //         }
  //     })
  //     .then((data) => {
  //         if (data && document[data.b]) {
  //             document[data.b].innerHTML = data.h;
  //         }
  //     })
  //     .catch((error) => {
  //         console.error(error);
  //     });
  // } catch (error) {
  //     console.error(
  //         "Unchecked runtime.lastError: The message port closed before a response was received."
  //     );
  // }

  return true;
}
function updateVariantStatuses(variants, optionElements) {
  optionElements.forEach((optionEl, optionIndex) => {
    if (optionIndex === 0) return;
    const optionNodes = [...optionEl.querySelectorAll('option')],
      previousValue = optionElements[optionIndex - 1].querySelector(':checked').value,
      availableValues = variants
        .filter((v) => v.available && v['option' + optionIndex] === previousValue)
        .map((v) => v['option' + (optionIndex + 1)]),
      existingValues = variants
        .filter((v) => v['option' + optionIndex] === previousValue)
        .map((v) => v['option' + (optionIndex + 1)]);
    optionNodes.forEach((optNode) => {
      (optNode.classList.remove('unavailable', 'non-existent'),
        existingValues.includes(optNode.getAttribute('value'))
          ? availableValues.includes(optNode.getAttribute('value'))
            ? (optNode.innerText = optNode.getAttribute('value'))
            : ((optNode.innerText = window.variantStrings.unavailable_with_option.replace(
                '[value]',
                optNode.getAttribute('value'),
              )),
              optNode.classList.add('unavailable'))
          : ((optNode.innerText = window.variantStrings.unavailable_with_option.replace(
              '[value]',
              optNode.getAttribute('value'),
            )),
            optNode.classList.add('non-existent')));
    });
  });
}
function findAvailableVariant(
  element,
  options,
  isRadio = true,
  fromCard = false,
  skipUnavailable = false,
) {
  for (let i = options.length - 1; i >= 0; i--) {
    const inputEl = isRadio
        ? element.querySelector('.product-form__input:nth-child(' + (i + 1) + ')')
        : element.querySelectorAll('.select')[i],
      inputType = isRadio
        ? inputEl.querySelector('.product-form__input__type').dataset.type
        : 'dropdown',
      inputs =
        inputType === 'dropdown'
          ? inputEl.querySelectorAll('option')
          : inputEl.querySelectorAll('input[type=\x22radio\x22]');
    let idx = Array.from(inputs).findIndex((input) => input.value === options[i]),
      found = false;
    while (idx < inputs.length - 1) {
      idx++;
      const input = inputs[idx];
      if (
        (!fromCard || !input.classList.contains('non-existent')) &&
        (!skipUnavailable || !input.classList.contains('unavailable'))
      ) {
        ((options[i] = input.value), (found = true));
        break;
      }
    }
    if (!found) {
      idx = Array.from(inputs).findIndex((input) => input.value === options[i]);
      while (idx > 0) {
        idx--;
        const input = inputs[idx];
        if (
          (!fromCard || !input.classList.contains('non-existent')) &&
          (!skipUnavailable || !input.classList.contains('unavailable'))
        ) {
          ((options[i] = input.value), (found = true));
          break;
        }
      }
    }
    if (found)
      return (
        inputType === 'dropdown'
          ? (inputEl.querySelector('.select__select').value = options[i])
          : (inputEl.querySelector('input[type="radio"][value="' + options[i] + '\x22]').checked =
              true),
        element.dispatchEvent(new Event('change')),
        true
      );
  }
  return false;
}
function displayPrices(price, compareAtPrice, priceEl, compareAtPriceEl, moneyFormat) {
  if (!moneyFormat) return;
  if (price && priceEl) {
    const formattedPrice = formatMoney(price, moneyFormat);
    priceEl.innerHTML = formattedPrice;
  }
  if (compareAtPrice && compareAtPriceEl) {
    const formattedCompareAtPrice = formatMoney(compareAtPrice, moneyFormat);
    ((compareAtPriceEl.innerHTML = formattedCompareAtPrice),
      compareAtPrice > price
        ? compareAtPriceEl.classList.remove('hidden')
        : compareAtPriceEl.classList.add('hidden'));
  }
}
function initTrapFocus() {
  if (document.querySelector('footer') && document.querySelector('footer').dataset['type'] === null)
    return false;
  return true;
}
function formatMoney(cents, format, noDecimals = false) {
  typeof cents == 'string' && (cents = cents.replace('.', ''));
  let value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatStr = format;
  function defaultOption(opt, defaultVal) {
    return typeof opt == 'undefined' ? defaultVal : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    ((precision = defaultOption(precision, 2)),
      (thousands = defaultOption(thousands, ',')),
      (decimal = defaultOption(decimal, '.')));
    if (isNaN(number) || number == null) return 0;
    number = (number / 100).toFixed(precision);
    let parts = number.split('.'),
      intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      decPart = parts[1] ? decimal + parts[1] : '';
    return (noDecimals && decPart === decimal + '00' && (decPart = ''), intPart + decPart);
  }
  switch (formatStr.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatStr.replace(placeholderRegex, value);
}
function initToggleUpsells() {
  const cartDrawer = document.querySelector('cart-drawer');
  cartDrawer &&
    cartDrawer
      .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
      .forEach((upsell) => {
        if (upsell.addRemoveFromCart) upsell.addRemoveFromCart();
      });
}
function playMedia() {
  if (!serial) {
    const themeScript = document.querySelector('script[data-animations-type]');
    serial = (themeScript && themeScript.dataset.animationsType) || '';
  }
}
